import React, { useEffect, useRef, useState } from "react";

const MathJaxRenderer = React.memo(
  ({ children, className = "", style = {} }) => {
    const elementRef = useRef(null);
    const [isRendered, setIsRendered] = useState(false);
    const renderIdRef = useRef(0);

    useEffect(() => {
      const element = elementRef.current;
      if (!element) return;

      const hasWindow = typeof window !== "undefined";
      const mathJax = hasWindow ? window.MathJax : undefined;
      const currentRenderId = ++renderIdRef.current;

      if (mathJax?.typesetClear) {
        try {
          mathJax.typesetClear([element]);
        } catch (_) {}
      }

      element.innerHTML = children || "";

      if (!mathJax?.typesetPromise) {
        setIsRendered(true);
        return;
      }

      mathJax
        .typesetPromise([element])
        .then(() => {
          if (currentRenderId === renderIdRef.current) {
            setIsRendered(true);
          }
        })
        .catch(() => {
          if (currentRenderId === renderIdRef.current) {
            setIsRendered(true);
          }
        });

      return () => {
        if (mathJax?.typesetClear && element) {
          try {
            mathJax.typesetClear([element]);
          } catch (_) {}
        }
      };
    }, [children]);

    return (
      <div
        ref={elementRef}
        className={className}
        style={{
          ...style,
          opacity: isRendered ? 1 : 0.7,
          transition: "opacity 0.2s ease-in-out",
        }}
      />
    );
  },
);

MathJaxRenderer.displayName = "MathJaxRenderer";

export default MathJaxRenderer;
